import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/home/Home';
import Footer from './components/Footer';
import GRIDxPage from './components/GRIDxPage';
import TeamPage from './components/TeamPage';
import MissionPage from './components/MissionPage';
import ContactPage from './components/ContactPage';
import CareersPage from './components/CareersPage';
import './App.css';

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gridx" element={<GRIDxPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/mission" element={<MissionPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/careers" element={<CareersPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
